import * as React from 'react';
import { IPolicyApplication, IPremium, IProduct } from '../../../../../../data/api/models';
import { IBrandingActions, II18nMessages } from '../../../../../../services/branding/models';
import { IQuoteActions, IQuoteState } from '../../../../../../services/quote/models';
import { Button, Col, Row } from 'react-bootstrap';
import { get, keys, map, reduce, size, startCase } from 'lodash';
import { Sticky, StickyContainer } from 'react-sticky'
import { FormattedNumber } from 'react-intl';
import { isRequired } from '../../../../../../util/validators';
import { Field } from 'redux-form';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import Benefit from '../../../../../Quote/scenes/SchemeChoice/components/Benefit';
import Loading from '../../../../../../components/Loading';
import { RenewalSubmitButton } from '../RenewalSubmitButton';

interface ChangeTierProps {
  product: IProduct;
  i18n: II18nMessages;
  dispatch: any;
  change: any;
  isLoading: boolean;
  quote: IQuoteState;
  formValues: IPolicyApplication;
  actions: {
    quote: IQuoteActions;
    branding: IBrandingActions;
  };
  goBackButton: any;
}

class ChangeTier extends React.Component<ChangeTierProps, any> {

  public state = {
    moreInfo: false,
  };

  constructor(props) {
    super(props);
    const { actions, product } = props;
    let productId = null;
    if (get(product, 'name', '') === 'Leisure Travel Renewal') {
      productId = product.id;
    }
    actions.quote.calculateRenewalQuotes(productId, true);
  }

  private standardiseTheName = (name) => startCase(name.replace('-', ' '));

  private isSelected = (quote, schemeId) => {
    return get(quote, 'scheme.id') === schemeId
  }

  private toggleMoreInfo = () => {
    this.setState((prevState) => ({
      moreInfo: !prevState.moreInfo,
    }));
  }

  private checkHasDiscount = (premium: IPremium): boolean => {
    const campaigns = get(premium, 'campaigns', []) || [];
    return (campaigns.length > 0) && get(premium, 'premiumBeforeAdjustment.gross', 0) > get(premium, 'gross', 0);
  }

  private renderQuotes = () => {
    const { quote, actions, formValues, isLoading, goBackButton } = this.props;
    const { moreInfo } = this.state;
    const quotes = quote.quotes;
    const product = actions.branding.getProduct();
    const schemeId = formValues.schemeId;
    const options = formValues.options;
    let tripTypeName = this.standardiseTheName(product.metadata.trip_type.annual);
    let hasDiscount = false;

    const orderedQuotes = product.metadata.scheme_order.map((order) => {
      return quotes[order];
    });

    const selectedTripTypeQuotes = map(orderedQuotes[0] && orderedQuotes, (tripTypes, level) => {
      if (size(tripTypes) === 1) {
        tripTypeName = keys(tripTypes)[0];
      }
      return tripTypes[tripTypeName]
    })

    const documentsOrder = [
      'Insurance Product Information Document',
      'Policy Wording',
    ];

    return (
      <div>
        <div className={'quote-container'}>
          <div className="quote-body">

            <Row className="quote-header-container">
              {map(selectedTripTypeQuotes, (schemePremium, index) => {
                hasDiscount = this.checkHasDiscount(schemePremium);
                return (
                  <Col xs={4} key={index}>
                    <div className="quote-header">
                      {get(schemePremium, 'scheme.coverLevel')}
                    </div>
                  </Col>)
              })}
            </Row>

            <Row>
              <Col>
                <StickyContainer className={'sticky-container-prices'}>
                  <Sticky>
                    {({
                        style,
                      }) => (
                      <div style={style} className={'sticky-prices'}>
                        <div className={hasDiscount ? 'quote-value-container discount' : 'quote-value-container'}>
                          {map(selectedTripTypeQuotes, (schemePremium, index) => {
                            const discountedPrice = get(schemePremium, 'premiumBeforeAdjustment.gross') ? get(schemePremium, 'premiumBeforeAdjustment.gross').toFixed(2) : 0.00;

                            return (
                              <Col xs={4}
                                   className={this.isSelected(schemePremium, schemeId) ? 'quote-prices selected' : 'quote-prices'}>
                                <h1 className={hasDiscount ? 'discount-price' : ''}>
                                  {get(schemePremium, 'gross') <= 0 ? (
                                    <span>
                                N/A
                              </span>
                                  ) : (
                                    <>
                                      {hasDiscount && (
                                        <div className={'discount-price-strikethrough'}>
                                          {'£' + discountedPrice}
                                        </div>
                                      )}
                                      <FormattedNumber
                                        value={schemePremium ? get(schemePremium, 'gross') : 0}
                                        style="currency"
                                        currency={schemePremium.currency}
                                      />
                                    </>
                                  )}
                                </h1>
                              </Col>
                            )
                          })}
                        </div>
                      </div>
                    )}
                  </Sticky>
                </StickyContainer>
              </Col>
            </Row>
            <Row className={'quote-select-container'}>
              {map(selectedTripTypeQuotes, (schemePremium, index) => {
                return (
                  <Col xs={4} className={`button-wrapper-${index}`} key={index}>
                    <div style={{ padding: '0 15px 0 15px' }}>
                      <Field
                        name="schemeId"
                        type="radio"
                        value={get(schemePremium, 'scheme.id')}
                        className="select-quote"
                        component={FieldFormControl}
                        validate={[isRequired]}
                      >
                        <div className={'select-quote-btn'}>
                          {this.isSelected(schemePremium, schemeId) ? 'selected' : 'select'}
                        </div>
                      </Field>
                    </div>
                  </Col>
                )
              })}
            </Row>
            {/*Documents*/}
            <Row className="quote-documents-container">
              {map(selectedTripTypeQuotes, (schemePremium, index) => {

                const documents = get(schemePremium, 'scheme.documents');
                const isAnnual = tripTypeName === 'Annual Multi Trip';
                const coverLevel = get(schemePremium, 'scheme.coverLevel');

                const filteredDocuments = reduce(keys(documents), (acc: any, current: string) => {
                  const isIpid = current.toLowerCase().includes('ipid');
                  const isCoverLevel = current.toLowerCase().includes(coverLevel);
                  const isSingle = current.toLowerCase().includes(tripTypeName.toLowerCase());
                  const isMultiTrip = isAnnual && current.toLowerCase().includes('multi-trip');

                  if (!isIpid || (isCoverLevel && (isSingle || isMultiTrip))) {
                    acc[current] = documents[current];
                  }

                  return acc;
                }, {});

                if (quote === null) {
                  return null;
                }

                return (
                  <Col xs={4} className={`document-wrapper-${index}`} key={index}>
                    <div className="quote-documents">
                      {map(documentsOrder, (documentName: string) => {
                        const documentUrl = get(filteredDocuments, documentName);
                        if (!documentUrl) {
                          return null;
                        }

                        let documentDisplayName = documentName;

                        if (documentName === 'Policy Wording') {
                          documentDisplayName = 'Travel Insurance Guide'
                        }

                        return (
                          <div style={{ padding: '0 15px 0 15px' }}>
                            <a className="btn btn-documents" href={documentUrl} target="_blank" key={documentName}>
                              {documentDisplayName}
                            </a>
                          </div>
                        );
                      })}
                    </div>
                  </Col>
                )
              })}
            </Row>

            {/*Benefits*/}
            <Benefit
              title={'Policy Excess'}
              selectedTripTypeQuotes={selectedTripTypeQuotes}
              definition={product.metadata.definitions.excess}
            />

            <Benefit
              title={'Medical Expenses'}
              selectedTripTypeQuotes={selectedTripTypeQuotes}
              definition={'Medical'}
            />

            <Benefit
              title="Trip Cancellation"
              definition={'Cancellation'}
              selectedTripTypeQuotes={selectedTripTypeQuotes}
            />

            <Benefit
              title="Personal belongings"
              definition={'Baggage'}
              selectedTripTypeQuotes={selectedTripTypeQuotes}
            />

            <Benefit
              title="Single item limit"
              definition={'single item limit'}
              selectedTripTypeQuotes={selectedTripTypeQuotes}
            />

            <Benefit
              title="Overall valuables limit"
              definition={'valuables total limit'}
              selectedTripTypeQuotes={selectedTripTypeQuotes}
            />

            <Benefit
              title="Winter sports"
              definition={product.metadata.definitions.winter_sports_alt_info}
              selectedTripTypeQuotes={selectedTripTypeQuotes}
              covered={options.winter_sports}
            />

            <Benefit
              title="Cruise cover"
              definition={product.metadata.definitions.cruise_cover_alt_info}
              selectedTripTypeQuotes={selectedTripTypeQuotes}
              covered={options.cruise_cover}
            />

            <Row>
              {map(selectedTripTypeQuotes, (quote, index) => {
                return (
                  <Col xs={4} key={index} className={`more-info-wrapper-${index}`}>
                    <div style={{ padding: '0 15px 15px 15px' }}>
                      <Button className="more-info-btn" block={true} onClick={this.toggleMoreInfo}>
                        {moreInfo ? 'Less info' : 'More info'}
                      </Button>
                    </div>
                  </Col>
                )
              })}
            </Row>

            {moreInfo && (
              <div>
                <Benefit
                  title="Personal accident"
                  definition={'Personal Accident'}
                  selectedTripTypeQuotes={selectedTripTypeQuotes}
                />
                <Benefit
                  title="Money & documents"
                  definition={'Money & Documents'}
                  selectedTripTypeQuotes={selectedTripTypeQuotes}
                />
                <Benefit
                  title="Personal liability"
                  definition={'Personal liability'}
                  selectedTripTypeQuotes={selectedTripTypeQuotes}
                />
                <Benefit
                  title="Delayed/missed departure"
                  definition={'Delayed or missed departure'}
                  selectedTripTypeQuotes={selectedTripTypeQuotes}
                />
                <Benefit
                  title="Legal assistance"
                  definition={'Legal assistance'}
                  selectedTripTypeQuotes={selectedTripTypeQuotes}
                />
                <Benefit
                  title="Catastrophe"
                  definition={'Catastrophe'}
                  selectedTripTypeQuotes={selectedTripTypeQuotes}
                />
                <Benefit
                  title="Hijack"
                  definition={'Hijack'}
                  selectedTripTypeQuotes={selectedTripTypeQuotes}
                />
                <Benefit
                  title="Gadget cover"
                  definition={'Gadget cover'}
                  selectedTripTypeQuotes={selectedTripTypeQuotes}
                  covered={options.gadget_cover}
                />
                <Benefit
                  title="Excess Waiver"
                  definition={'Excess Waiver'}
                  selectedTripTypeQuotes={selectedTripTypeQuotes}
                  covered={options.excess_waiver}
                />
              </div>
            )}
          </div>
        </div>
        <div className={'renewal-edit-form-buttons'} style={{ marginBottom: '20px' }}>
          <div className={'renewal-go-back-button'}>
            {goBackButton}
          </div>
          <div className={'renewal-submit-button'}>
            <RenewalSubmitButton
              isLoading={isLoading}
            />
          </div>
        </div>
      </div>
    )
  }

  public render() {
    const { isLoading } = this.props;

    if (isLoading) {
      return (
        <Loading/>
      )
    }

    return (
      <div className="scheme-choice-section">
        <div className="available-quotes">
          <>
            {!isLoading && this.renderQuotes()}
          </>
        </div>
      </div>
    );
  }
}

export default ChangeTier;
